import React from 'react'

const ScrollIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="scroll-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 200, 100, 1)" />
          <stop offset="100%" stopColor="rgba(255, 150, 100, 1)" />
        </linearGradient>
        <filter id="scroll-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path 
        d="M4 6C4 4.89543 4.89543 4 6 4H14L20 10V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z" 
        stroke="url(#scroll-gradient)" 
        strokeWidth="2"
        filter="url(#scroll-glow)"
      />
      <path 
        d="M14 4V10H20M8 14H16M8 17H13" 
        stroke="url(#scroll-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#scroll-glow)"
      />
      <circle cx="8" cy="10" r="0.5" fill="url(#scroll-gradient)" />
      <circle cx="10" cy="10" r="0.5" fill="url(#scroll-gradient)" />
      <circle cx="12" cy="10" r="0.5" fill="url(#scroll-gradient)" />
    </svg>
  )
}

export default ScrollIcon
